import { Button } from 'react-bootstrap';
import "./Proceed_btn.css";

function Proceed_btn({ onClick, btnText, className = "" }) {
    return (
        <>
            <section className="Proceed_btn_holder">
                <Button className={`proceed_btn ${className}`} onClick={onClick}>
                    {btnText}
                </Button>
            </section>
        </>
    );
}

export default Proceed_btn;
